var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvBatteryTemperatureAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2507 6.75016L17.7507 6.75016M23.2507 10.4168L17.7507 10.4168M23.2507 14.0835L17.7507 14.0835M9.04232 16.6115V8.12516C9.04232 6.85951 10.0683 5.8335 11.334 5.8335C12.5996 5.8335 13.6257 6.85951 13.6257 8.12516V16.6115C14.7311 17.3514 15.459 18.6116 15.459 20.0418C15.459 22.32 13.6122 24.1668 11.334 24.1668C9.05581 24.1668 7.20898 22.32 7.20898 20.0418C7.20898 18.6116 7.93683 17.3514 9.04232 16.6115ZM12.2507 20.0418C12.2507 20.5481 11.8402 20.9585 11.334 20.9585C10.8277 20.9585 10.4173 20.5481 10.4173 20.0418C10.4173 19.5356 10.8277 19.1252 11.334 19.1252C11.8402 19.1252 12.2507 19.5356 12.2507 20.0418Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBatteryTemperatureAlert);
export default __webpack_public_path__ + "static/media/evBatteryTemperatureAlert.9ad033dc4968f2b54af6be349ce85d06.svg";
export { ForwardRef as ReactComponent };